import React from 'react';
import './HeroSection.css';
import EmailForm from './EmailForm';

function HeroSection() {
  const handleError = (errorMessage) => {
    alert(errorMessage);
  };

  return (
    <div className="home-c">
      <div className="home-c-layout">
        {/* Left Section - Content and Form */}
        <div className="home-c-left">
          <div className="hero-content">
            <h1 className="hero-title">
              Insights Stripped To What Matters
            </h1>
            <p className="hero-description">
              Personalized market reports for all capital markets (stocks, crypto, forex, derivatives and more) 100% your way.
            </p>
          </div>
          
          <div className="form-section">
            <EmailForm 
              placeholder="you@example.com"
              buttonText="Join Free"
              onError={handleError}
            />
          </div>
        </div>

        {/* Right Section - Vector Background with Image */}
        <div className="home-c-right">
          <div className="image-container">
            <img 
              src="/assets/old/home_1.png" 
              alt="Market Analysis" 
              className="hero-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
